import { render, staticRenderFns } from "./table-nfe.vue?vue&type=template&id=c4490d2e&scoped=true&"
import script from "./table-nfe.vue?vue&type=script&lang=js&"
export * from "./table-nfe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4490d2e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/table-nfe.vue
// module id = 109
// module chunks = 1